import { render, staticRenderFns } from "./order-view.vue?vue&type=template&id=bbcddd36&scoped=true&"
import script from "./order-view.vue?vue&type=script&lang=js&"
export * from "./order-view.vue?vue&type=script&lang=js&"
import style0 from "./order-view.vue?vue&type=style&index=0&id=bbcddd36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcddd36",
  null
  
)

export default component.exports